module.exports = __webpack_public_path__ + "img/GAME_WORDFERRISWHEEL2.a90119ec.jpg";